import { useMemo } from "react";
import { useSelector } from "react-redux";
import { SUPER_ADMIN_EMAILS } from "./usePermissionsHook";

// "High-level users" — exact-match email list (case-sensitive, as before).
// Exported so a screen can evaluate it for someone other than the signed-in
// user (the drilldown Admin tab lists who passes each gate).
export const HIGH_LEVEL_USER_EMAILS = [
  "joliva@cliffcomortgage.com",
  "dev@arrowservicing.com",
  "dev1@arrowservicing.com",
  "dev2@arrowservicing.com",
  "dev1@cliffcomortgage.com",
  "cwolpert@cliffcomortgage.com",
  "shyrose@arrowservicing.com",
  "ryanw@arrowservicing.com",
  "holden.hargrave@Lendmarq.com",
  "holden.hargrave@lendmarq.com",
  "cnguyen@cliffcomortgage.com",
];

export const isHighLevelEmail = (email) =>
  !!email && HIGH_LEVEL_USER_EMAILS.includes(email);

export const useReduxHook = () => {
  const user = useSelector((state) => state.user);
  const userEmail = useMemo(() => user?.emailAddress, [user]);
  const isDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "dev@arrowservicing.com" ||
      user?.emailAddress === "dev1@arrowservicing.com" ||
      user?.emailAddress === "dev2@arrowservicing.com" ||
      user?.emailAddress === "shyrose@arrowservicing.com" ||
      user?.emailAddress === "ryanw@arrowservicing.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com",

    [user]
  );

  const isTempDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev@arrowservicing.com" ||
      user?.emailAddress === "dev1@arrowservicing.com" ||
      user?.emailAddress === "dev2@arrowservicing.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com" ||
      user?.emailAddress === "shyrose@arrowservicing.com" ||
      user?.emailAddress === "ryanw@arrowservicing.com" ||
      user?.emailAddress === "holden.hargrave@Lendmarq.com" ||
      user?.emailAddress === "holden.hargrave@lendmarq.com" ||
      user?.emailAddress === "cnguyen@cliffcomortgage.com",
    [user]
  );

  const isHighLevelUser = useMemo(
    () => isHighLevelEmail(user?.emailAddress),
    [user]
  );

  const isAdmin = useMemo(() => {
    const permissions = user?.permissions || [];
    // A super admin is always an admin, even without the "admin" permission —
    // admin access must always include super admins (see SUPER_ADMIN_EMAILS in
    // usePermissionsHook.js).
    const email = user?.emailAddress?.toLowerCase();
    const isSuperAdmin =
      !!email &&
      SUPER_ADMIN_EMAILS.map((e) => e.toLowerCase()).includes(email);
    return permissions.includes("admin") || isSuperAdmin;
  }, [user]);

  return {
    user,
    userEmail,
    isTempDevUser,
    isDevUser,
    isHighLevelUser,
    isAdmin,
  };
};
